import * as React from "react";
import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Panel, Separator, Text } from "@nju/ui";
import { ITvRegistrationMode } from "./types";

interface ITvRegistrationSuccessProps {
  option: ITvRegistrationMode;
  userId: string | undefined;
}

export function TvRegistrationSuccess({
  option,
  userId,
}: ITvRegistrationSuccessProps) {
  const header =
    option === "ADD_CODE" ? "kod poufny został utworzony" : "już prawie gotowe";
  const content =
    option === "ADD_CODE"
      ? "Masz już swój kod poufny, a dane potrzebne do logowania do telewizji mobilnej wyślemy\n Ci wkrótce SMS-em. Znajdziesz je też w aplikacji i po zalogowaniu na stronie nju.pl."
      : "Twój nowy kod poufny zacznie działać w ciągu kilku minut.";

  return (
    <Panel testId="tv-registration-success-panel">
      <div className="flex items-center flex-col">
        <Text
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          {header}
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="only-mobile:w-12 only-mobile:h-12 w-[90px] h-[90px]"
          name="user-lock-check"
        />
        <Separator size="s" tone="invisible" />
        <BlockText
          align="center"
          className="whitespace-pre-line"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          {content}
        </BlockText>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Link
          href={portalRoutes.mojeKonto.index.get({
            mode: "mobile",
            ...(userId && { userId }),
          })}
          passHref={true}
        >
          <A
            className="only-mobile:text-center"
            display={{
              "@onlyMobile": "block",
            }}
            size={{ "@onlyMobile": "s" }}
          >
            ok
          </A>
        </Link>
      </div>
    </Panel>
  );
}
